import { GALLERY_CONSTS } from 'pro-gallery-lib';
export const behaviourParams_item_clickAction = {
  ...GALLERY_CONSTS.behaviourParams_item_clickAction,
  EXPAND: 'EXPAND',
  FULLSCREEN: 'FULLSCREEN'
};
//# sourceMappingURL=behaviourParams_item_clickAction.js.map